/**
 * Add new item at the end of the array.
 * @param {Array} array - Array to which the item is added.
 * @param {*} item - Item to add to the array.
 * @return {Array} New array with the added item.
 */
export default function immutablePush(array, item) {
  return [...array, item];
}
